module.exports = __webpack_public_path__ + "static/media/pocket.7506019e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pocket.svg
// module id = 504
// module chunks = 98